var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"item"},[_c('ui-clickable',_vm._b({staticClass:"link",on:{"click":function($event){return _vm.$emit('click', $event)}}},'ui-clickable',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }